import { render, staticRenderFns } from "./WalletReport.vue?vue&type=template&id=605f4675&"
import script from "./WalletReport.vue?vue&type=script&lang=js&"
export * from "./WalletReport.vue?vue&type=script&lang=js&"
import style0 from "./WalletReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports